import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { S_TextNumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextNumberValue/TextNumberValue';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    value?: string;
    width?: string;
    autoFocus?: boolean;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    className?: string;
    style?: CSSProperties;
}

export const SearchValue = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value ?? '');
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_SearchValue className={props.className} $width={props.width}>
            <S_Icon icon={['fal', 'magnifying-glass']} />
            <S_Input
                ref={ref}
                style={props.style}
                type="text"
                value={value ?? ''}
                placeholder={Localization.SEARCH}
                autoComplete="nope"
                autoFocus={props.autoFocus}
                onChange={(e) => {
                    setValue(e.target.value);
                    props.onChange?.(e.target.value);
                }}
                onBlur={() => {
                    props.onBlur?.(value);
                }}
                onKeyDown={(e) => {
                    e.stopPropagation();
                }}
            />
        </S_SearchValue>
    );
};

const S_SearchValue = styled.div<{ $width?: string }>`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    display: flex;
    width: ${(props) => props.$width ?? '100%'};
`;

const S_Icon = styled(FontAwesomeIcon)`
    color: #141c54;
    position: absolute;
    left: 15px;
    font-size: 20px;
`;

const S_Input = styled(S_TextNumberValue)<{ $width?: string }>`
    padding-left: 50px;
    text-align: left;
    width: 100%;
    font-size: 13px;
    &:focus {
        background: #f5f5f5;
    }
`;
